import React from 'react';

const ComparisonTableEventsData = (props) => {
    const {data} = props;

    //console.log("ComparisonTableEventsData selectedData", data);

    if (!data) {
        return <p>No data available</p>;
    }

    return (
        <table className='w-full standard-table'>
            <tbody>
                <tr>
                    <td>Origen</td>
                    <td>{data ? data.sourceLocations.join(', ') : 'N/A'}</td>
                </tr>
                <tr>
                    <td>Destino</td>
                    <td>{data ? data.destinationLocations.join(', ') : 'N/A'}</td>
                </tr> 
                <tr>
                    <td>Fecha</td>
                    <td>{data ? data.eventTime : 'N/A'}</td>
                </tr>         
            </tbody>
        </table>
    );
};

export default ComparisonTableEventsData;
